import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const Nav = () => {
  const location = useLocation();
  const onBooking = location.pathname.startsWith("/book");

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/70 backdrop-blur-xl border-b border-border"
    >
      <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-3 group"
        >
          <div className="w-8 h-8 bg-ink-900 grid place-items-center">
            <span className="font-display text-champagne text-lg leading-none">D</span>
          </div>
          <div className="leading-tight">
            <div className="font-display text-lg text-ink-900">Del Cid</div>
            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground -mt-0.5">
              Productions
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-10 text-sm">
          <a href="/#services" data-testid="nav-services" className="hover:text-champagne transition-colors">Services</a>
          <a href="/#process" data-testid="nav-process" className="hover:text-champagne transition-colors">Process</a>
          <a href="/#faq" data-testid="nav-faq" className="hover:text-champagne transition-colors">FAQ</a>
          <a href="/#contact" data-testid="nav-contact" className="hover:text-champagne transition-colors">Contact</a>
        </nav>

        {!onBooking && (
          <Link to="/book" data-testid="header-book-btn">
            <Button className="rounded-none bg-ink-900 hover:bg-ink-800 text-white px-6 py-5 font-mono text-xs tracking-[0.2em] uppercase">
              Book a deposition
            </Button>
          </Link>
        )}
      </div>
    </header>
  );
};

export default Nav;
